module.exports = __webpack_public_path__ + "static/media/Cathie Larocca Headshot.a6d0c111.jpeg";